import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { RepcoService }           from './repco.service';
import { RepcoSettingsComponent } from './repco.settings.component';
import { RepcoStates }            from './repco.states';
import { SharedModule }           from '../shared/shared.module';
import { VendorsModule }          from '../vendors/vendors.module';

@NgModule({
  declarations: [
    RepcoSettingsComponent
  ],
  entryComponents: [
    RepcoSettingsComponent
  ],
  imports: [
    SharedModule,
    VendorsModule,

    UIRouterUpgradeModule.forChild({ states: RepcoStates })
  ],
  providers: [
    RepcoService
  ]
})
export class RepcoModule {}
